import React, { useState, useCallback, useEffect } from 'react';
import { TextField } from '@superops/ui-design-system';
import { useIntl } from 'react-intl';
import { getTranslatedText } from '@nile/components';

function TextInputField(props) {
  const { label } = props.attribute;

  const intl = useIntl();

  const { multiline } = props;

  const [value, setValue] = useState(props.value || '');

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleChange = useCallback((newValue) => {
    setValue(newValue);
    props.handleChange(newValue);
  }, []);

  return (
    <div className="w100">
      <TextField
        placeholder={getTranslatedText(intl, 'common.placeholder.enterValue')}
        type="text"
        label={label}
        value={value}
        onChange={handleChange}
        multiline={multiline}
      />
    </div>
  );
}

export default TextInputField;
